<div class="beleglos-wrapper">
  <jf-icon
    [name]="'file'"
    [iconColor]="'#9D9D9D'"
    [size]="70"
    [strokeWidth]="0.3"
  ></jf-icon>

  <p class="title">Wähle einen Beleg aus, den du der Zahlung zuordnest.</p>

  <p class="description">Du kannst die Zahlung auch ohne Beleg tätigen.</p>

  <jf-button
    [variant]="'outline'"
    (doClick)="doOpenBelegChooser()"
  >
    Beleg auswählen
  </jf-button>
</div>
